import React from "react";
import Layout3 from "components/layout/Layout3";
import ViceMayor from "./Vicemayor";

const ViceMayorDetails = (props) => {
  return (
    <Layout3>
      <ViceMayor {...props} />
    </Layout3>
  );
};

export default ViceMayorDetails;
